module.exports = __webpack_public_path__ + "static/scale-model-of-botanica,-the-wichita-gardens-in-wichita-kansas-3bd5cc440a6875052464e045f2fbcb0f.png";